/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { PopOut } from "@cd2/components"
import { Card } from "./Card"
import { useTheme } from "@cd2/theme"
import { CGButton, IIcon } from "./CGButton"
import { Flex } from "./Flex"

interface Item {
  children: React.ReactNode
  leftIcon?: IIcon
  onClick?(e: any): void
  rightIcon?: IIcon
  to?: string
  buttonStyle?: "outline" | "text" | "solid"
  buttonColor?: string | { color: string; hover: string }
  disabled?: boolean
}

interface IProps {
  target(isActive?: boolean): React.ReactNode
  items: (Item | (() => React.ReactNode))[]
  disabled?: boolean
}

export function DropdownMenu({ target, items, disabled }: IProps) {
  const { borderRadius } = useTheme()

  return (
    <div
      onClick={e => e.stopPropagation()}
      css={css`
        ${disabled
          ? css`
              pointer-events: none;
            `
          : ""}
      `}
    >
      <PopOut
        placement="bottomRightInner"
        offset={{ vertical: 4 }}
        target={target}
        render={() => (
          <Card
            css={css`
              overflow: hidden;
              padding: 0;
            `}
          >
            <Flex alignItems="stretch" direction="column">
              {items.map((item, i) => {
                if (typeof item === "function") {
                  return <div key={i}>{item()}</div>
                } else {
                  return (
                    <CGButton
                      key={i}
                      buttonColor={{ color: "#ffffff", hover: "#f1f1f1" }}
                      {...item}
                      children={item.children}
                      extendTheme={{
                        borderRadius: {
                          topLeft: i === 0 ? borderRadius / 2 : 0,
                          topRight: i === 0 ? borderRadius / 2 : 0,
                          bottomRight: i === items.length - 1 ? borderRadius / 2 : 0,
                          bottomLeft: i === items.length - 1 ? borderRadius / 2 : 0,
                        },
                      }}
                      buttonProps={{
                        block: true,
                        css:
                          i !== 0
                            ? css`
                                border-top: none;
                              `
                            : ``,
                      }}
                    />
                  )
                }
              })}
            </Flex>
          </Card>
        )}
        closeOnClick
      />
    </div>
  )
}
